import { FC, useState } from "react";

import { Box } from "@mui/material";

import { ContactUsDialog } from "./ContactUsDialog/ContactUsDialog";
import { useContactUsForm } from "./helpers/useContactUsForm";

import { AmplitudeEvents } from "@/common/constants/amplitude";
import { useAmplitude } from "@/common/hooks/amplitude/useAmplitude";
import { useTranslate } from "@/common/hooks/useTranslate";
import { FormButton } from "@/forms-design-system/FormButton";
import { Mail } from "@/icons/outlined";

interface ContactUsProps {
  organizationPageId: string;
  organizationName: string;
  isPreview: boolean;
  isDialogOpenInPreview: boolean;
}

export const ContactUs: FC<ContactUsProps> = ({
  organizationPageId,
  organizationName,
  isPreview,
  isDialogOpenInPreview,
}) => {
  const { t } = useTranslate();
  const { logAmplitudeEvent } = useAmplitude();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { form, submit, sendErrorMessage, sentToEmail, reset } = useContactUsForm({ organizationPageId });

  const openDialog = () => {
    logAmplitudeEvent(AmplitudeEvents.OrgPageContactUsClicked);
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
    reset();
  };

  const dialogProps = { organizationName, form, onSubmit: submit, sendErrorMessage, sentToEmail };

  return (
    <>
      <FormButton
        variant="rounded"
        startIcon={<Mail />}
        components={{ startIcon: { size: "small" } }}
        onClick={isPreview ? undefined : openDialog}
        data-test="org-page-contact-us-button"
      >
        {t("organization", "contactUs.button")}
      </FormButton>
      {isPreview ? (
        isDialogOpenInPreview && (
          <Box
            sx={(theme) => ({
              position: "fixed",
              inset: 0,
              zIndex: theme.zIndex.modal,
              display: "flex",
              flexDirection: "column",
              "& > *": { flex: 1, display: "flex", alignItems: "center" },
              "& > * > *": { width: "100%" },
            })}
          >
            <ContactUsDialog {...dialogProps} onSubmit={() => {}} open inline onClose={() => {}} />
          </Box>
        )
      ) : (
        <ContactUsDialog {...dialogProps} open={isDialogOpen} onClose={closeDialog} />
      )}
    </>
  );
};
